"use client";

import Link from "next/link";
import { ComponentProps } from "react";
import { COUNTRY_CODE_KEY, disableCountryCodeList, getInitialCountryCode } from "@/00-shared/const";
function withCountryCode(Component: typeof Link) {
  return function WrappedLink(props: ComponentProps<typeof Link>) {
    const {
      href,
      ...rest
    } = props;
    const target = props.target;
    const countryCode = getInitialCountryCode();
    if (typeof window === "undefined") {
      return <Component {...rest} href={href} />;
    }
    const url = new URL(href.toString(), window.location.origin);
    if (!disableCountryCodeList.some(item => url.pathname.startsWith(item))) {
      url.searchParams.set(COUNTRY_CODE_KEY, countryCode);
    }
    return <Component {...rest} href={url.toString()} suppressHydrationWarning prefetch={target !== "_blank"} />;
  };
}
const LinkWithCountryCode = withCountryCode(Link);
export default LinkWithCountryCode;